import { DragDropModule } from '@angular/cdk/drag-drop';
import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatCoreModule } from '@big-direkt/chat-core';
import { JsonApiClientModule, MapperInjectorService } from '@big-direkt/json-api-client';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { UiSpinnerModule } from '@big-direkt/ui/spinner';
import { IconComponent } from '@big-direkt/utils/icons';
import { BotComponent } from './bot/bot.component';
import { InputComponent } from './bot/components/input/input.component';
import { MessageComponent } from './bot/components/message/message.component';
import { RatingComponent } from './bot/components/rating/rating.component';
import { ChatConfigurationMapper } from './chat-configuration.mapper';
import { ChatComponent } from './chat.component';
import { LiveComponent } from './live/live.component';
import { ChatToggleComponent } from './toggle/chat-toggle.component';

@NgModule({
    declarations: [
        BotComponent,
        ChatComponent,
        ChatToggleComponent,
        InputComponent,
        LiveComponent,
        MessageComponent,
        RatingComponent,
    ],
    imports: [
        AsyncPipe,
        ChatCoreModule,
        DragDropModule,
        FormsModule,
        IconComponent,
        JsonApiClientModule,
        NgClass,
        UiButtonComponent,
        UiSpinnerModule,
    ],
    exports: [
        ChatComponent,
        ChatToggleComponent,
    ],
    providers: [
        { provide: MapperInjectorService.tokens[ChatConfigurationMapper.type], useClass: ChatConfigurationMapper },
    ],
})
export class ChatClientModule {
}
